import merge from 'lodash.merge'

export default {
  setZones(state, zones) {
    state.zones = zones
  },
  setZoneGroups(state, zonegroups) {
    state.zoneGroups = zonegroups
  },
  setAdmTerritories(state, admTerritories) {
    state.admTerritories = admTerritories
  },
  setSeparatedTerritories(state, territories) {
    state.separatedTerritories = territories
  },
  setSettings(state, settings) {
    state.settings = { ...state.settings, ...settings }
  },
  setColoring(state, payload) {
    state.coloring = payload
  },
  setAdmLevels(state, payload) {
    state.admLevels = payload
  },

  setPeriods(state, payload) {
    state.periods = payload
  },
  setSeasons(state, seasons) {
    state.seasons = seasons
  },
  setYears(state, years) {
    state.years = years
  },
  setColors(state, colors) {
    state.colors = colors
  },
  setConvertfunctions(state, convertfunctions) {
    state.convertfunctions = convertfunctions
  },
  setEconomicModels(state, economicModels) {
    state.economicModels = economicModels
  },
  setLogo(state, logo) {
    state.logo = logo
  },

  // OLD MUTATIONS
  createNewLayer(state, layer) {
    state.userLayers.push(layer)
  },
  changeZoneLayers(state, payload) {
    state.enabledZoneLayers = { ...payload }
  },
  showAdmTerritory(state, payload) {
    let [zone_id, terr_id] = payload
    if (!state.enabledZoneLayers[zone_id]) {
      state.enabledZoneLayers[zone_id] = {}
    }
    state.enabledZoneLayers[zone_id][terr_id] = true
    state.enabledZoneLayers = { ...state.enabledZoneLayers }
  },
  hideTerritory(state, payload) {
    let [zone_id, terr_id] = payload
    state.enabledZoneLayers[zone_id][terr_id] = false
    state.enabledZoneLayers = { ...state.enabledZoneLayers }
  },
  zoneSelected(state, id) {
    state.zoneSelectedId = id
  },
  setHelperType(state, type) {
    state.helperType = type
  },
  setTheme(state, theme) {
    state.theme = theme
  },
  setApiVersion(state, data) {
    state.apiVersion = data
  },
  setTreatments(state, data) {
    state.treatments = data
  },
  setEmitterCategorytypes(state, data) {
    state.emitterCategorytypes = data
  },
  setInitLoading(state, data) {
    state.isInitLoading = data
  },
  setApiError(state, error) {
    state.apiError = error
  },
  setApiErrorInfo(state, error) {
    state.apiError = { info: error }
  },
  setItems(state, { items }) {
    state.items = items
  },

  setTerschemaListCount(state, count) {
    state.terschemaListCount = count
  },

  setControlListCount(state, count) {
    state.controlListCount = count
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js